import React from 'react';
import './CapacityHeatmap.css';

export type WxbCapacityLevel = 'idle' | 'normal' | 'busy' | 'over';

export interface WxbCapacityCell {
  key: string;
  label: React.ReactNode;
  value?: React.ReactNode;
  level?: WxbCapacityLevel;
  detail?: React.ReactNode;
}

export interface WxbCapacityRow {
  key: string;
  label: React.ReactNode;
  cells: WxbCapacityCell[];
}

export interface WxbCapacityHeatmapProps extends React.HTMLAttributes<HTMLDivElement> {
  columns: React.ReactNode[];
  rows: WxbCapacityRow[];
  density?: 'comfortable' | 'compact';
}

const joinClasses = (...classes: Array<string | false | undefined>) =>
  classes.filter(Boolean).join(' ');

export const WxbCapacityHeatmap: React.FC<WxbCapacityHeatmapProps> = ({
  columns,
  rows,
  density = 'comfortable',
  className = '',
  ...props
}) => (
  <div className={joinClasses('wxb-capacity-heatmap', `wxb-capacity-heatmap-${density}`, className)} {...props}>
    <div className="wxb-capacity-header">
      <div className="wxb-capacity-row-label wxb-capacity-row-label-head">资源</div>
      {columns.map((column, index) => (
        <div className="wxb-capacity-col-label" key={index}>{column}</div>
      ))}
    </div>
    {rows.map((row) => (
      <div className="wxb-capacity-row" key={row.key}>
        <div className="wxb-capacity-row-label">{row.label}</div>
        {row.cells.map((cell) => (
          <div className={joinClasses('wxb-capacity-cell', `wxb-capacity-cell-${cell.level ?? 'normal'}`)} key={cell.key}>
            <span className="wxb-capacity-cell-value">{cell.value ?? cell.label}</span>
            {cell.detail && <span className="wxb-capacity-cell-detail">{cell.detail}</span>}
          </div>
        ))}
      </div>
    ))}
  </div>
);

